import React from 'react';

import MuiFormControl, {
  FormControlProps as MuiFormControlProps,
} from '@mui/material/FormControl';
import clsx from 'clsx';

import { CoreProps } from '../types';
import { withCoreProps } from '../withCoreProps';

export const FormControl = withCoreProps<FormControlProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<FormControlProps>) => {
    // const classes = useStyles({});
    const clsxClass = clsx(className);

    return (
      <MuiFormControl {...props} className={clsxClass}>
        {children}
      </MuiFormControl>
    );
  },
);

export interface FormControlProps extends MuiFormControlProps, CoreProps {}
